import QUERY from '@/api_app/CustomerWarn'
import { Toast } from 'vant';

const getDefaultState = () => {
  return {
    CustomerWarnData: [],
    getMessageDetail:{},
    WarnPage: 0,
    warnListLength: 0,
    scrollTopValue: 0,
    saveMinTime: '',
    startTime: '',
    endTime: '',
  }
}

const state = getDefaultState()

const mutations = {
  SET_DATA: (state, { key, data }) => {
    state[key] = data;
  },
  offset_set: (state, data)=>{
    state['WarnPage'] = data
  },
  warnListLength: (state,data)=>{
    state['warnListLength'] = data.data
  }
}

const actions = {
  CustomerWarning({ commit }, params) {
    return new Promise((resolve, reject) => {
      QUERY({ key:'CustomerWarning' ,params}).then(response => {
        const { data } = response
          let CustomerWarnData = state.CustomerWarnData || []
          if (state.WarnPage == 0) {
            CustomerWarnData = data.data
          } else {
            for(let i in data.data) {
              CustomerWarnData.push(data.data[i])
            }
          }
          commit('SET_DATA',{ key:'CustomerWarnData', data: CustomerWarnData })
          commit('warnListLength', { key: 'warnListLength', data: state.warnListLength+=1 })
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

